export function mindshareProfiling() {
  return typeof window !== "undefined" && new URLSearchParams(window.location.search).get("mindsharePerf") === "1";
}

export function recordMindshareTiming(name, start, end = performance.now()) {
  if (mindshareProfiling()) performance.measure(`mindshare:${name}`, { start, end });
}

export function recordMindshareValue(name, value) {
  if (mindshareProfiling()) performance.mark(`mindshare:${name}:${value}`);
}

export function timeMindshare(name, build) {
  if (!mindshareProfiling()) return build();
  const start = performance.now();
  try { return build(); } finally { recordMindshareTiming(name, start); }
}

export function profileMindshareRender(id, phase, actualDuration, baseDuration, startTime, commitTime) {
  recordMindshareTiming(`react-${phase}`, startTime, startTime + actualDuration);
}
